"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatientInformationDto = instanceOfPatientInformationDto;
exports.PatientInformationDtoFromJSON = PatientInformationDtoFromJSON;
exports.PatientInformationDtoFromJSONTyped = PatientInformationDtoFromJSONTyped;
exports.PatientInformationDtoToJSON = PatientInformationDtoToJSON;
exports.PatientInformationDtoToJSONTyped = PatientInformationDtoToJSONTyped;
/**
 * Check if a given object implements the PatientInformationDto interface.
 */
function instanceOfPatientInformationDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined)
        return false;
    return true;
}
function PatientInformationDtoFromJSON(json) {
    return PatientInformationDtoFromJSONTyped(json, false);
}
function PatientInformationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'dateOfBirth': json['dateOfBirth'],
    };
}
function PatientInformationDtoToJSON(json) {
    return PatientInformationDtoToJSONTyped(json, false);
}
function PatientInformationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'dateOfBirth': value['dateOfBirth'],
    };
}
//# sourceMappingURL=PatientInformationDto.js.map